export const GAME_TITLE = "Connections - MLB Edition";
export const MAX_MISTAKES = 4;
